import styled from 'styled-components/macro';

export const FilterWrapper = styled.div`
    width: 172px;
    margin-top: 10px;
`;

export const ProjectsListWrapper = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
`;
